import React from 'react';
import {Grid, Table, TableBody, TableRow, TableCell} from '@mui/material';
import {makeStyles} from "@mui/styles";

import {colorLabel, SubTitle} from '../'

const useStyles = makeStyles(() => ({
  profileContainer: {
    width: 500,
  },
  rowLabel: {
    color: colorLabel,
  },
  table: {
    marginTop: 17,
    '& td': {
      paddingTop: 7,
      paddingBottom: 7,
      border: 'none',
    },
    '& td:first-child': {
      paddingLeft: 0,
      width: 90,
    },
  },
}));

function Row(props: any) {
  const classes = useStyles();
  const {name, value} = props
  return (
    <TableRow>
      <TableCell className={classes.rowLabel}>{name}</TableCell>
      <TableCell>{value}</TableCell>
    </TableRow>
  )
}

export default function SubTitleProfileInquiry(props: any) {
  const classes = useStyles();
  const {profile, orderer} = props;

  return (
    <Grid container direction={"column"} spacing={6}>
      <Grid item>
        <div className={classes.profileContainer}>
          <SubTitle>{'법인 정보'}</SubTitle>
          {profile && (
            <Table className={classes.table}>
              <TableBody>
                <Row name={'사업번호'} value={profile.businessNumber}/>
                <Row name={'회사명'} value={profile.name}/>
                <Row name={'대표자명'} value={profile.representative}/>
                <Row name={'업종'} value={profile.industryType}/>
                <Row name={'주소'} value={profile.address}/>
                <Row name={'이메일'} value={profile.email}/>
              </TableBody>
            </Table>
          )}
        </div>
      </Grid>

      <Grid item>
        <div className={classes.profileContainer}>
          <SubTitle>{'담당자 정보'}</SubTitle>
          {orderer && (
            <Table className={classes.table}>
              <TableBody>
                <Row name={'이름'} value={orderer.name}/>
                <Row name={'연락처'} value={orderer.phone}/>
                <Row name={'이메일'} value={orderer.email}/>
              </TableBody>
            </Table>
          )}
        </div>
      </Grid>

    </Grid>
  );
}
